import {createReducer, on} from '@ngrx/store';
import { ExportTemplatesActions } from './export-templates.actions';
import {TableSummary} from 'daisy-design-system-front';

export const exportTemplatesFeatureKey = 'Reporting-export-templates';

export interface ExportTemplatesState {
    tableSummary: TableSummary | null;
    totalItems: number;
    errorMessage: string | null;
    loading: boolean;
    hasError: boolean;
}

export const initialExportTemplates: ExportTemplatesState = {
    tableSummary: { rows: [] },
    totalItems: 0,
    errorMessage: null,
    loading: true,
    hasError: false
};

export const exportTemplatesReducer = createReducer(
    initialExportTemplates,
    on(
        ExportTemplatesActions.fetchSuccess,
        (state, { response }): ExportTemplatesState => ({
            ...state,
            tableSummary: {rows: response.list?.map(item => ({...item})) },
            totalItems: response.paging.totalItems,
            loading: false,
            errorMessage: null,
        })
    ),
    on(ExportTemplatesActions.fetchFailure,
        (state, {message}) => ({
            ...state,
            errorMessage: message,
            loading: false,
            hasError: true
        })
    )
);
